import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalService } from '@shared/modal/modal.service';
import { catchError, tap } from 'rxjs';

@Injectable()
export class GetStartedService {
    private readonly modalService = inject(ModalService);
    private readonly http = inject(HttpClient);

    public emailFormControl = new FormControl('', [Validators.email]);

    public sendEmail(): void {
        // TODO(andriikamaldinov1): think about how to handle when the value is empty
        if (this.emailFormControl.invalid || !this.emailFormControl.value) {
            return;
        }

        const email = this.emailFormControl.value;

        this.modalService.open();

        this.http
            .post('/send-email', {
                main: [{ field: 'Email', value: email }],
            })
            .pipe(
                tap(() => {
                    this.resetEmailControl();
                    this.modalService.changeToSuccess();
                }),
                catchError(() => {
                    this.resetEmailControl();
                    this.modalService.changeToError();
                    return '';
                }),
            )
            .subscribe();

        this.resetEmailControl();
    }

    public resetEmailControl(): void {
        this.emailFormControl.reset();
    }
}
